export default "__VITE_ASSET__Bt0ZVwy2__"